import {createActionsWorkflowsRoutes} from '@github-ui/actions-workflows/routes/create-actions-workflows-routes'
import {lazyActionsWorkflowsRouteComponents} from '@github-ui/actions-workflows/routes/lazy-route-components'
import {createCodeViewRoutes} from '@github-ui/code-view/routes/create-code-view-routes'
import {lazyCodeViewRouteComponents} from '@github-ui/code-view/routes/lazy-route-components'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- The repo app composes the existing commits app routes during incremental onboarding.
import {createCommitsRoutes} from '@github-ui/commits/routes/create-commits-routes'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- The repo app composes the existing commits app routes during incremental onboarding.
import {lazyCommitsRouteComponents} from '@github-ui/commits/routes/lazy-route-components'
import {createIssuesRoutes} from '@github-ui/issues/routes/create-issues-routes'
import {lazyIssuesRouteComponents} from '@github-ui/issues/routes/lazy-route-components'
import {createPullRequestsRoutes} from '@github-ui/pull-requests/routes/create-pull-requests-routes'
import {lazyPullRequestsRouteComponents} from '@github-ui/pull-requests/routes/lazy-route-components'
import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {repoAppBuilder} from './config/app-builder'
import {createRepoAgentsRoutes} from '@github-ui/repo-agents/routes/create-repo-agents-routes'
import {lazyRepoAgentsRouteComponents} from '@github-ui/repo-agents/routes/lazy-route-components'
import {repoLayoutRoute} from './routes/repo-layout-route'
import {withRepoRouteHandle} from './routes/repo-route-handle'
import {RepoLayout} from './pages/RepoLayout'
import {
  isActionsWorkflowsEnabled,
  isAgentsEnabled,
  isCodeViewEnabled,
  isCommitsEnabled,
  isIssuesEnabled,
  isPullRequestsEnabled,
} from '@github-ui/repo-app-flags'
import {RepoErrorBoundary} from './components/RepoErrorBoundary'

const agentRoutes = () => {
  if (!isAgentsEnabled()) {
    return []
  }
  return createRepoAgentsRoutes(repoAppBuilder, lazyRepoAgentsRouteComponents)
}

const actionsWorkflowsRoutes = () => {
  if (!isActionsWorkflowsEnabled()) {
    return []
  }
  return createActionsWorkflowsRoutes(repoAppBuilder, lazyActionsWorkflowsRouteComponents)
}

const issuesRoutes = () => {
  if (!isIssuesEnabled()) {
    return []
  }
  return createIssuesRoutes(repoAppBuilder, lazyIssuesRouteComponents)
}

const pullRequestsRoutes = (params: {isEnabled: (feature: string) => boolean | undefined}) => {
  if (!isPullRequestsEnabled()) {
    return []
  }
  return createPullRequestsRoutes(repoAppBuilder, params, lazyPullRequestsRouteComponents)
}

const codeViewRoutes = () => {
  if (!isCodeViewEnabled()) {
    return []
  }
  return createCodeViewRoutes(repoAppBuilder, lazyCodeViewRouteComponents)
}

const commitsRoutes = () => {
  if (!isCommitsEnabled()) {
    return []
  }
  return createCommitsRoutes(repoAppBuilder, lazyCommitsRouteComponents)
}

export const repoApp = repoAppBuilder.createDataRouterAppFromRoutes(params => [
  repoLayoutRoute.toRoute({
    Component: RepoLayout,
    errorBoundary: {override: RepoErrorBoundary},
    children: [
      ...withRepoRouteHandle(agentRoutes(), {repoSubAppName: 'repo-agents', selectedLink: 'repo_agents'}),
      ...withRepoRouteHandle(codeViewRoutes(), {repoSubAppName: 'code-view', selectedLink: 'repo_source'}),
      ...withRepoRouteHandle(issuesRoutes(), {repoSubAppName: 'issues', selectedLink: 'repo_issues'}),
      ...withRepoRouteHandle(pullRequestsRoutes(params), {repoSubAppName: 'pull-requests', selectedLink: 'repo_pulls'}),
      ...withRepoRouteHandle(actionsWorkflowsRoutes(), {
        repoSubAppName: 'actions-workflows',
        selectedLink: 'repo_actions',
      }),
      ...withRepoRouteHandle(commitsRoutes(), {repoSubAppName: 'commits', selectedLink: 'repo_commits'}),
    ],
  }),
])

registerDataRouterApp(repoApp)
